import { observable } from 'mobx';

import { BusyFormState } from 'src/util/busy-form';
import { FieldState, FormState } from 'formstate';
import { emailValidator } from 'src/util/validators';

export interface EmailActionResult {
    message: string;
    emailSent: boolean;
}

export class EmailFormState extends BusyFormState {
    @observable emailSent = false;
    @observable message: string | undefined;

    email = new FieldState('').validators(emailValidator);

    form = new FormState({
        email: this.email,
        isBusy: this.isBusy,
    });

    constructor(private submitAction: (email: string) => Promise<EmailActionResult>) {
        super();
        this.form.validate();
    }

    handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const email = this.email.$;
        this.emailSent = false;
        this.message = undefined;
        this.withBusy(this.submitAction(email)).then(
            ({ message, emailSent }) => {
                this.message = message;
                this.emailSent = emailSent;
            },
            (error) => {
                this.message = error.toString();
            }
        );
    };

    clearError = () => {
        this.message = undefined;
    };
}
